import store from "@/store";
import { RESPONSE_STATUS } from "../constants/responseStatuses";

const getAuthorizationHeader = () => {
  const { token } = store.getters;
  const headers = {};

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

export async function get(url) {
  const response = await fetch(url, {
    method: "GET",
    cache: "no-cache",
    mode: "cors",
    credentials: "include",
    headers: getAuthorizationHeader()
  });
  return convertResponse(response);
}

export async function put(url, body) {
  const response = await fetch(url, {
    method: "PUT",
    cache: "no-cache",
    mode: "cors",
    credentials: "include",
    headers: {
      ...getAuthorizationHeader(),
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  });
  return convertResponse(response);
}

export async function post(url, body) {
  const response = await fetch(url, {
    method: "POST",
    cache: "no-cache",
    mode: "cors",
    credentials: "include",
    headers: {
      ...getAuthorizationHeader(),
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  });
  return convertResponse(response);
}

async function convertResponse(response) {
  const contentType = response.headers.get("content-type");
  const data = contentType && (await response.json());
  switch (true) {
    case response.status === RESPONSE_STATUS.SUCCESS:
      return data;
    case response.status === RESPONSE_STATUS.SUCCESS_NO_CONTENT:
      return;
    case response.status === RESPONSE_STATUS.NOT_FOUND &&
      data?.reason === "ProcedureNotFound":
      return {};
    default:
      throw new Error(data?.message ?? response.status);
  }
}
